// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResizableModal__container___r_OPH {
    position: absolute;

    background-color: var(--color-bg-default);
    border: 0.1rem solid var(--color-bg-border);
    border-radius: 0.4rem;
    box-shadow: var(--shadow-modal);
}

.ResizableModal__iconResize___l8JqI {
    position: absolute;
    rotate: 180deg;
}

.ResizableModal__iconResizeRightBottom___WyLOp {
    cursor: nw-resize;
    position: absolute;
    right: 0;
    bottom: 0;
}

.ResizableModal__iconResizeLeftTop___XGG9h {
    cursor: se-resize;
    position: absolute;
    top: 0;
    rotate: 180deg;
}

.ResizableModal__iconResizeBottom___NZ4Gf {
    cursor: ne-resize;
    bottom: 0;
    rotate: 90deg;
}

.ResizableModal__iconResizeTop___t4eu7 {
    cursor: se-resize;
    top: 0;
    rotate: 180deg;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/ResizableModal/ResizableModal.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;;IAElB,yCAAyC;IACzC,2CAA2C;IAC3C,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,MAAM;IACN,cAAc;AAClB","sourcesContent":[".container {\n    position: absolute;\n\n    background-color: var(--color-bg-default);\n    border: 0.1rem solid var(--color-bg-border);\n    border-radius: 0.4rem;\n    box-shadow: var(--shadow-modal);\n}\n\n.iconResize {\n    position: absolute;\n    rotate: 180deg;\n}\n\n.iconResizeRightBottom {\n    cursor: nw-resize;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n}\n\n.iconResizeLeftTop {\n    cursor: se-resize;\n    position: absolute;\n    top: 0;\n    rotate: 180deg;\n}\n\n.iconResizeBottom {\n    cursor: ne-resize;\n    bottom: 0;\n    rotate: 90deg;\n}\n\n.iconResizeTop {\n    cursor: se-resize;\n    top: 0;\n    rotate: 180deg;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ResizableModal__container___r_OPH`,
	"iconResize": `ResizableModal__iconResize___l8JqI`,
	"iconResizeRightBottom": `ResizableModal__iconResizeRightBottom___WyLOp`,
	"iconResizeLeftTop": `ResizableModal__iconResizeLeftTop___XGG9h`,
	"iconResizeBottom": `ResizableModal__iconResizeBottom___NZ4Gf`,
	"iconResizeTop": `ResizableModal__iconResizeTop___t4eu7`
};
export default ___CSS_LOADER_EXPORT___;
